import classnames from "classnames";
import { makeStyles } from "components/providers/makeStyles";
import { Typography } from "@mui/material";
import { T } from "../../../util/t";

const useSectionStyles = makeStyles((theme) => ({
    section: {
        borderTop: `1px solid ${theme.palette.border.light}`,
        paddingTop: theme.spacing(2),
        marginTop: theme.spacing(3),
        "& p": {
            margin: theme.spacing(1, 0, 0, 0)
        }
    },
    heading: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(2),
        "& .MuiButton-root": {
            minWidth: "auto"
        }
    }
}));
export const DialogSectionLayout = ({ title, action, children, className }) => {
    const classes = useSectionStyles();

    return (
        <section className={classnames(classes.section, className)}>
            <div className={classes.heading}>
                <Typography variant="h5"><T>{title}</T></Typography>
                {action}
            </div>
            {children}
        </section>
    );
};


